import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
import { EntityIdParams } from "models/propTypes/urlParamsTypes";
import { AutocompleteListItem } from "models/propTypes/listPropTypes";
//#endregion
//#region components
import { BreadCrumb, PageLayouts, SettingsFormViewPanel, useMountedState } from "components/common";
import { useParams } from "react-router-dom";
import SettingsFormContainer from "./forms/settingsFormContainer";
import { useArticleService, useInvoiceService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";

const ArticleSettings: React.FC = (props) => {
  const urlParams = useParams<EntityIdParams>();
  const id = Number.parseInt(urlParams.id ?? "0");
  const { getMounted } = useMountedState();

  const articleService = useArticleService();
  const invoiceService = useInvoiceService();

  const [article, setArticle] = React.useState<WintSuperkollAPIModel.Article>();
  const [units, setUnits] = React.useState<AutocompleteListItem[]>();

  React.useEffect(() => {
    invoiceService
      .getUnits()
      .then((res) => {
        if (res && res.length > 0) {
          const newUnits = res.map(
            (item): AutocompleteListItem => ({
              id: item.id,
              value: item.name ?? "",
            })
          );
          setUnits(newUnits.reverse());
        } else setUnits([]);
      })
      .catch(() => setUnits([]));
  }, []);

  const loadArticle = () => {
    articleService
      .get(id)
      .then((result) => {
        if (getMounted()) {
          setArticle(result);
        }
      })
      .catch((e) => {
        console.warn("error");
      });
  };

  React.useEffect(() => {
    loadArticle();
  }, [id]);

  return (
    <PageLayouts.EntityFullScreen
      entityKey={`article-settings`}
      id={id ?? 0}
      navigation={
        <BreadCrumb
          prevItems={[
            {
              text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Articles),
              href: UrlHelper.formatPath("/Reports/Articles"),
            },
            { text: article?.text ?? "", href: UrlHelper.formatPath(`/Article/${id}/`) },
          ]}
          current={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Settings)}
          showHome
        />
      }
    >
      {article && units ? (
        <PageLayouts.SettingsLayout
          title={article.text ?? ""}
          navItems={[
            {
              navKey: "articleSettings",
              title: TranslationKeys.Common.Settings,
              content: (
                <SettingsFormViewPanel successMessage={TranslationKeys.Article.ArticleUpdateSuccess}>
                  <SettingsFormContainer article={article} units={units} />
                </SettingsFormViewPanel>
              ),
            },
          ]}
        ></PageLayouts.SettingsLayout>
      ) : (
        <></>
      )}
    </PageLayouts.EntityFullScreen>
  );
};

export default ArticleSettings;
